import { addLogoutHook, setApiBase, setOnline, setTokenStore } from "../api";
import { ALLOW_INSECURE_LOCAL, DEFAULT_SERVER, isNativeRuntime, nativePlatform } from "./platform";
import { unregisterPush } from "./push";
import { initSecureStore, secureTokenStore } from "./secureToken";
import { loadServerUrl, validateServerUrl } from "./serverUrl";

/**
 * Runs before React renders in the native shell: server URL (hidden setting or build default), bearer token in the
 * secure store, brand status bar, connectivity, and push clean-up on sign-out. A browser build does nothing here.
 */
export async function initNative(): Promise<void> {
  if (!isNativeRuntime()) return;
  const root = document.documentElement;
  root.classList.add("native", "native-" + nativePlatform());
  try {
    const saved = await loadServerUrl();
    const v = saved ? validateServerUrl(saved, { allowInsecureLocal: ALLOW_INSECURE_LOCAL }) : null;
    setApiBase(v && v.ok ? v.url : DEFAULT_SERVER);
  } catch { setApiBase(DEFAULT_SERVER); }
  try { await initSecureStore(); setTokenStore(secureTokenStore); } catch { /* falls back to the in-memory store */ }
  addLogoutHook(unregisterPush);
  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    await StatusBar.setStyle({ style: Style.Dark }); // light text on the brand colour
    if (nativePlatform() === "android") { await StatusBar.setOverlaysWebView({ overlay: false }); await StatusBar.setBackgroundColor({ color: "#00706B" }); /* Senvia logo teal */ }
  } catch { /* plugin missing */ }
  try {
    const { Network } = await import("@capacitor/network");
    setOnline((await Network.getStatus()).connected);
    await Network.addListener("networkStatusChange", (s) => setOnline(s.connected));
  } catch { /* browser events remain */ }
}
